module.exports = __webpack_public_path__ + "img/comp-friendly-elec.0fbb72b1.svg";